import apiClient from '../utils/apiClient';

/**
 * Room + CleanupAction API Services
 * Quản lý phòng và catalog hành động dọn (per-branch).
 */

const buildRoomPayload = (data = {}) => {
  const payload = {};
  if (data.branchId !== undefined) payload.branch_id = data.branchId;
  if (data.name !== undefined) payload.name = data.name;
  if (data.slug !== undefined) payload.slug = data.slug;
  if (data.description !== undefined) payload.description = data.description;
  if (data.amenities !== undefined) payload.amenities = data.amenities;
  if (data.imageUrls !== undefined) payload.image_urls = data.imageUrls;
  if (data.capacity !== undefined) payload.capacity = Number(data.capacity);
  if (data.hourlyPrice !== undefined) {
    payload.hourly_price = Number(data.hourlyPrice);
  }
  if (data.minBookingGuests !== undefined) {
    payload.min_booking_guests =
      data.minBookingGuests === '' || data.minBookingGuests === null
        ? null
        : Number(data.minBookingGuests);
  }
  if (data.defaultCleanupActions !== undefined) {
    payload.default_cleanup_actions = data.defaultCleanupActions;
  }
  if (data.isActive !== undefined) payload.is_active = data.isActive;
  if (data.sortOrder !== undefined) payload.sort_order = Number(data.sortOrder);
  // #154555 — gửi KÈM trong chính request lưu phòng; máy chủ đồng bộ `Branch.private_rooms`
  // trong cùng giao dịch, không còn request thứ hai tách rời để hỏng lẻ.
  if (data.bookable !== undefined) payload.bookable = !!data.bookable;
  return payload;
};

export const roomAPI = {
  getRooms: async (params = {}) => apiClient.get({ url: '/rooms', params }),
  getRoomById: async (id) => apiClient.get({ url: `/rooms/${id}` }),
  createRoom: async (data) =>
    apiClient.post({ url: '/rooms', data: buildRoomPayload(data) }),
  updateRoom: async (id, data) =>
    apiClient.put({ url: `/rooms/${id}`, data: buildRoomPayload(data) }),
  deleteRoom: async (id) => apiClient.delete({ url: `/rooms/${id}` }),
};

const buildActionPayload = (data = {}) => {
  const payload = {};
  if (data.branchId !== undefined) payload.branch_id = data.branchId;
  if (data.code !== undefined) payload.code = data.code;
  if (data.label !== undefined) payload.label = data.label;
  if (data.icon !== undefined) payload.icon = data.icon;
  if (data.sortOrder !== undefined) payload.sort_order = Number(data.sortOrder);
  if (data.isActive !== undefined) payload.is_active = data.isActive;
  return payload;
};

export const cleanupActionAPI = {
  getActions: async (params = {}) =>
    apiClient.get({ url: '/table-cleanup/actions', params }),
  createAction: async (data) =>
    apiClient.post({ url: '/table-cleanup/actions', data: buildActionPayload(data) }),
  updateAction: async (id, data) =>
    apiClient.put({ url: `/table-cleanup/actions/${id}`, data: buildActionPayload(data) }),
  deleteAction: async (id) =>
    apiClient.delete({ url: `/table-cleanup/actions/${id}` }),
};
